import Constants from "./Constants";


const formattedSpanishNetworks = (netList = [], noNetworkText = '') => {
    const mpi = { name: 'Red MultiPlan', value: [] };
    const phcs = { name: 'Red PHCS', value: [] };
    const other = { name: 'Otras Redes', value: [] };
    let otherIndex = -1;

    if (netList != null && netList.length > 0) {
        netList.forEach((net) => {
            if (Constants.HIDE_NETWORK_CODES.includes(net.networkCode)) {
                return;
            }
            handleNetwork(net, mpi, phcs, other, noNetworkText);
        });
    }

    if (otherIndex !== -1) {
        other.value.push(other.value.splice(otherIndex, 1)[0]);
    }

    return { mpi, phcs, other };

    function handleNetwork(net, mpiVal, phcsVal, otherVal, noNetworkTextVal) {
        switch (net.networkCode) {
            case "PHCS":
                formatPHCSNetwork(net);
                phcsVal.value.push(net);
                break;
            case "MPI":
                formatMPIName(net);
                mpiVal.value.push(net);
                break;
            default:
                handleOtherNetworks(net, otherVal, noNetworkTextVal);
                break;
        }
    }

    function formatPHCSNetwork(net) {
        net.networkStatementName = net.networkStatementName.replace("(", "<i>(").replace(")", ")</i>");
    }

    function formatMPIName(net) {
        if (net.networkStatementName === "No veo ninguna de estas declaraciones en mi tarjeta de") {
            net.networkStatementName = "<i>No veo ninguna de estas declaraciones en mi tarjeta de</i>";
        }
    }

    function handleOtherNetworks(net, otherVal, noNetworkTextVal) {
        if (net.networkCode === "IDONTSEEONE") {
            otherIndex = otherVal.value.length; // Keep track of the index for "IDONTSEEONE"
            net.networkStatementName += noNetworkTextVal;
        }
        otherVal.value.push(net);
    }
}

export { formattedSpanishNetworks };